import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreferencesService } from '../../preferences/preferences-service/preferences.service';
import { ETimelineGroup, TPreferences } from '../../preferences/preferences.model';
import { GET_PREFERENCES } from '../../preferences/preferences.store';

@Injectable({
  providedIn: 'root',
})
export class TimelineGroupService {
  constructor(private preferencesService: PreferencesService) {}

  setGrouping(value: ETimelineGroup): Observable<TPreferences> {
    const preferences = GET_PREFERENCES();

    const body: Partial<TPreferences> = {
      timeline: {
        timeframe: preferences.timeline?.timeframe ? preferences.timeline?.timeframe : null,
        group: value,
      },
    };

    return this.preferencesService.updatePreferences(body);
  }
}
